var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "6",
      "width": "20"
    }
  }, [_vm._v("必要能力")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "width": "60",
      "rowspan": "2"
    }
  }, [_vm._v("口语能力")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "width": "160"
    }
  }, [_vm._v("用对应语言做自我介绍，用对应语言介绍一款自己近期玩的游戏")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("口语能力好，外语地道，流利，无口音")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("口语基本流利，偶尔有口音")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("口语偶尔卡顿，可以听懂")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("结结巴巴，沟通吃力")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("无法口语沟通")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "160"
    }
  }, [_vm._v("在做介绍的时候全程非常流利，无卡顿，可以使用较长的句子进行介绍。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "160"
    }
  }, [_vm._v("做介绍时会出现短暂的停顿，多数情况下比较顺利，说话可能带有一点口音。")]), _vm._v(" "), _c('td', [_vm._v("口语交流中出现一些卡顿，但是面试官可以听懂")]), _vm._v(" "), _c('td', [_vm._v("口语交流不太顺畅，无法完整地说话一整句话。")]), _vm._v(" "), _c('td', [_vm._v("完全不能用口语沟通。")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "width": "60",
      "rowspan": "2"
    }
  }, [_vm._v("翻译能力")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("用对应外语翻译游戏词汇。游戏词汇翻译，例如攻击力，暴击，魔法值，式神，服务器更新，应用商店，闪退，停服维护。")]), _vm._v(" "), _c('td', [_vm._v("能很好的覆盖普通翻译，以及游戏翻译")]), _vm._v(" "), _c('td', [_vm._v("能很好的覆盖普通翻译")]), _vm._v(" "), _c('td', [_vm._v("翻译中存在少量错误")]), _vm._v(" "), _c('td', [_vm._v("翻译错误较多")]), _vm._v(" "), _c('td', [_vm._v("翻译结果难以阅读")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("可以清楚理解面试官所问内容，不会反复询问"), _c('br'), _vm._v("对于文本理解准确并且有自己的思考。可以对游戏词汇做出比较准确的翻译")]), _vm._v(" "), _c('td', [_vm._v("可以理解面试官所问内容，但是理解上存在偏差导致问题回答存在问题，对于文本理解较为准确但停留在表层，字面意思，对游戏词汇翻译不太准备。")]), _vm._v(" "), _c('td', [_vm._v("对游戏词汇不理解，翻译时有少量的错误，大致语义还是正确的。")]), _vm._v(" "), _c('td', [_vm._v("翻译时错误较多，语义已经完全偏离")]), _vm._v(" "), _c('td', [_vm._v("无法进行翻译工作。")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("本地化经验")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("列举几种当地游戏发行时需要注意的事项？"), _c('br'), _vm._v("\r\n        如果项目组想做一次调研，大额内购和小额内购，哪一种受玩家欢迎，你会怎么做？"), _c('br'), _vm._v("\r\n        说说看当地人专有的节假日，并结合这个节假日主题设计一个游戏活动")]), _vm._v(" "), _c('td', [_vm._v("有本地化工作经验"), _c('br'), _vm._v("对于面试中涉及文化的部分有自己的理解，甚至主动发起提问")]), _vm._v(" "), _c('td', [_vm._v("对于面试中涉及文化的部分有自己的理解，甚至主动发起提问")]), _vm._v(" "), _c('td', [_vm._v("面试过程中没有注意各地文化问题，在提醒后能够说出正确解答")]), _vm._v(" "), _c('td', [_vm._v("面试过程中没有注意各地文化问题，在提醒后能够作答，但不准确，和理想结果有偏差")]), _vm._v(" "), _c('td', [_vm._v("面试过程中没有注意各地文化问题，提醒后依然不会作答，或者回答完全错误")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("有海外生活经验，能对当地的文化和节日了如指掌，了解当地人的生活习惯，每日作息等，了解当地游戏市场的热门趋势。有丰富的本地化发型经验")]), _vm._v(" "), _c('td', [_vm._v("了解当地的文化和节日，有海外生活经验，游戏相关涉及较少，但是可以通过人际关系等方法解决问题。本地化注意点回答较完整，比如：文化差异，超框。")]), _vm._v(" "), _c('td', [_vm._v("不太了解当地的特色节日和文化风俗，但是如果给出一个文化问题，还是可以有自己的理解和解决方案。有本地化经验，但没有完整参加过一个项目。")]), _vm._v(" "), _c('td', [_vm._v("不太了解当地的特色节日和文化风俗，给出一个文化的问题以后，解决方案也不太合理。没有本地化经验。")]), _vm._v(" "), _c('td', [_vm._v("对本地化的概念不理解，给不出相关解决方案。")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("加分项")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("游戏理解")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\r\n        可以从游戏切入，也可以从其他该同学熟悉的行业（例如：直播，短视频等）切入"), _c('br'), _vm._v("\r\n        以游戏切入为例："), _c('br'), _vm._v("\r\n        1.你最喜欢的角色是什么？他的特点是什么？"), _c('br'), _vm._v("\r\n        2.你有办法解决你所提到的这个角色的缺点吗？"), _c('br'), _vm._v("\r\n        3.你觉得从提升游戏整体体验方面有哪些可以做的"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\r\n        以直播为例："), _c('br'), _vm._v("\r\n        1. 你喜欢的主播是谁？他的日常直播内容是什么？"), _c('br'), _vm._v("\r\n        2. 你觉得这个主播他有缺点吗?如果你是他该如何改进？"), _c('br'), _vm._v("\r\n        3. 直播圈变动意向很大，要长久在此立足该如何去做呢？\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("1. 对该业务（游戏和系统）有深度理解"), _c('br'), _vm._v("\r\n          2. 能提出熟悉业务（游戏）的优点，缺点和建议"), _c('br'), _vm._v("\r\n          3. 能对业务（游戏）细节有独到的理解"), _c('br'), _vm._v("\r\n          4. 能够针对目前业务（游戏）情况给出更好的建议"), _c('br'), _vm._v("\r\n          5. 对行业（游戏）的发展理解比较好"), _c('br')]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 对业务（游戏和系统）有较深度理解"), _c('br'), _vm._v("\r\n        2. 能提出熟悉业务（游戏）的优点，缺点和建议"), _c('br'), _vm._v("\r\n        3. 能对业务（游戏）细节有独到的理解"), _c('br'), _vm._v("\r\n        4. 能够针对目前业务（游戏）情况给出一定的建议"), _c('br'), _vm._v("\r\n        5. 能同步了解行业（游戏）发展趋势\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 对业务（游戏和系统）有较深度理解"), _c('br'), _vm._v("\r\n        2. 能提出熟悉业务（游戏）的优点，缺点和想法"), _c('br'), _vm._v("\r\n        3. 能对业务（游戏）细节有独到的理解"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（不能提出有效建议）")])]), _vm._v(" "), _c('td', [_vm._v("\r\n        1.停留在业务表层（玩游戏）"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("2.从自己感觉出发不是站在整体业务（游戏）角度来理解具体内容")]), _c('br'), _vm._v("\r\n        3.对业务（游戏）本身没有太多想法和建议"), _c('br')]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 对业务（游戏本身类型和玩法）理解都有偏差"), _c('br'), _vm._v("\r\n        2. 单纯只是娱乐手段"), _c('br')]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\r\n        1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，这个英雄的特色是通过"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("短cd技能造成高额伤害")]), _vm._v("，可以"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("通过操作提高这个英雄的强度")]), _vm._v("，不是脸滚键盘的那种。当然缺点也很明显，他的"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("下限非常低")]), _vm._v("，他的强度预计在中等水平，但是LOL大量的低年龄段玩家造成了存在较多的低水平亚索玩家拉低了这个角色的风评，但是无论如何，这个英雄很快乐。"), _c('br'), _vm._v("\r\n        2. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("这个角色的缺点其实也是他的优点")]), _vm._v("，正因为他的下限低，所以设计师才可以提高他的上限，这样也是一种平衡。如果我们需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("提升他的下限，那么也需要降低他的上限")]), _vm._v("。一个英雄为什么弱？大概可以分为，容易死，技能难以释放，技能伤害低，那么我们可以简单从这几个方面来提升这个英雄，提高这英雄的生命，将非指向性技能修改为指向性技能，那么这个英雄的伤害我们是否还应该提高呢？我觉得不能，因为我们已经强化了生存以及技能释放难度，这提升了他的下限，如果还提高伤害，那么上限也提升了，"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("这会破坏游戏的平衡。")]), _c('br'), _vm._v("\r\n        3. 我觉得lol还有一定的发展前景，但是需要"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("关注手游的发展趋势，")]), _vm._v("可以考虑在"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("缩短游戏时间，提升排位体验")]), _vm._v("方面做一些文章，比如加快游戏的节奏，提升兵线的经验、金钱，惩罚游戏内演员，给一些具体的方案等等\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 我最喜欢LOL中的疾风剑豪这个角色，这个英雄的特色是"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("比较秀")]), _vm._v("，可以"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("通过操作提高这个英雄的强度")]), _vm._v("，不是脸滚键盘的那种。当然缺点也很明显，他的"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("下限非常低")]), _vm._v("，他的平均强度在中等偏下，但是LOL大量的低年龄段玩家造成了存在较多的低水平玩家拉低了这个角色的风评，但是无论如何，这个英雄很快乐。"), _c('br'), _vm._v("\r\n          2. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("这个角色的缺点其实也是他的优点")]), _vm._v("，正因为他的下限低，所以设计师才可以提高他的上限，这样也是一种平衡。如果我们需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("提升他的下限，那么也需要降低他的上限")]), _vm._v("。一个英雄为什么弱？大概可以分为，容易死，技能难以释放，技能伤害低，那么我们可以简单从这几个方面来提升这个英雄，提高这英雄的生命，将非指向性技能修改为指向性技能，提高这个英雄的伤害值"), _c('br'), _vm._v("\r\n          3. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("我觉得lol做的挺好的，或许他应该做一个手游试试看")]), _vm._v("（你知道王者荣耀吗？玩的不多吧，你觉得LOL手游版可以从哪些方面胜过王者荣耀呢？对游戏业的趋势不敏锐）\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，这个英雄可以"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("展现我的操作")]), _vm._v("，不是脸滚键盘的那种。我玩这个英雄胜率很高。"), _c('br'), _vm._v("\r\n          2. 这个角色的缺点我认为是使用难度高，可以考虑适当"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("降低这个英雄的使用难度")]), _vm._v("：提高这英雄的生命，将非指向性技能修改为指向性技能，提高这个英雄的伤害值"), _c('br'), _vm._v("\r\n          3. "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("总得来说目前游戏体验挺好的，他们最好把游戏内的导演和演员全部封禁")]), _vm._v("（具体怎么做呢？给不出有效的方案）\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，我玩这个英雄胜率很高。"), _c('br'), _vm._v("\r\n          2. 缺点是容易死吧，"), _c('span', {
    staticClass: "green"
  }, [_vm._v("可能是我操作问题，提升下操作就好了")]), _vm._v("，我觉得可以出一些教学视频来教我们如何克服操作难度比较高的问题"), _c('br'), _vm._v("\r\n          3. 没什么想法，可能可以做pve吧（PVE已经有了，游戏体验不深入）\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 我觉得什么英雄我都喜欢，要说最喜欢，那就是疾风剑豪，没什么原因就是感觉比较喜欢他"), _c('br'), _vm._v("\r\n          2. 缺点是容易死吧，可能是我操作问题，提升下操作就好了"), _c('br'), _vm._v("\r\n          3. 没什么想法可能可以做pve吧（PVE已经有了，游戏体验不深入）\r\n      ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("综合素质")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("执行能力、沟通能力、工作态度"), _c('br'), _vm._v("考察软素质，例如分配一个任务怎么准备，怎么执行，遇到困难怎么处理")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 计划完备有风险预案"), _c('br'), _vm._v("\r\n          2. 表达自信，有同理心，能主动表达"), _c('br'), _vm._v("\r\n          3. 有较强的抗压能力、会主动承担工作\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 计划较完备但没有风险预案"), _c('br'), _vm._v("\r\n        2. 表达自信，能主动表达"), _c('br'), _vm._v("\r\n        3. 有较强的抗压能力\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 需要给出提示才可以有较满意的计划"), _c('br'), _vm._v("\r\n        2. 表达顺畅"), _c('br'), _vm._v("\r\n        3. 负责任务可以正常完成，但其他工作需要敦促\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 逻辑混乱，计划错误很多"), _c('br'), _vm._v("\r\n        2. 沟通过程卡顿，需要面试官给予较多的提示"), _c('br'), _vm._v("\r\n        3. 负责任务有较多遗漏，需要不停跟进\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 计划不可执行、为人易于放弃"), _c('br'), _vm._v("\r\n          2. 沟通困难"), _c('br'), _vm._v("\r\n          3. 反对加班\r\n        ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\r\n        计划团建会单对单询问，可以听取他人的建议结合实际情况确认是否可行，计划中包含了诸如飞机延误，门票售罄等情况的预案"), _c('br'), _vm._v("\r\n        在该计划没有得到上级审核通过的情况，能分析具体原因并且加班解决该问题，在发现潜在问题后主动汇报并且尝试解决该问题\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        计划团建会单对单询问，会多次和他人沟通确认方案"), _c('br'), _vm._v("\r\n        在该计划没有得到上级审核通过的情况，能分析具体原因并且加班解决该问题，发现潜在问题后会主动汇报问题\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        计划团建会单对单询问，但是对于不同人员的异议处理不佳，单纯给出主观见解"), _c('br'), _vm._v("\r\n        在该计划没有得到上级审核通过的情况，尝试加班解决该问题\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        计划只是对人员意见的汇总，没有单独的沟通"), _c('br'), _vm._v("\r\n        计划存在一定的矛盾，例如：未考虑到前往机场登机时间，行程过紧几乎无法实现"), _c('br'), _vm._v("\r\n        主管提出问题后简单修改，提交后没得到反馈的情况下人不在了"), _c('br')]), _vm._v(" "), _c('td', [_vm._v("\r\n        自己私自定下计划，没有沟通的过程"), _c('br'), _vm._v("\r\n        目光闪烁，顾左右而言他"), _c('br'), _vm._v("\r\n        对于加班非常抗拒"), _c('br')]), _vm._v(" "), _c('td')])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48701d8e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/score-tips/score-tips-verify-qa.vue
// module id = null
// module chunks = 